import React, { useState, useCallback, useEffect } from 'react';
import Map, { Popup } from 'react-map-gl';
import Pin from '../components/Pin';
import { Link } from 'react-router-dom';
import { TStore, useAppDispatch } from '../store';
import 'mapbox-gl/dist/mapbox-gl.css';
import { setSelectedVessel } from '../slices/averageFleetSlice';

import mapboxgl from 'mapbox-gl';
import { useSelector } from 'react-redux';
import { getFleetAverage } from '../actions/fleetAverageAction';

// The following is required to stop "npm build" from transpiling mapbox code.
// notice the exclamation point in the import.
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_API_KEY;

interface MapState {
  latitude: number | undefined;
  longitude: number | undefined;
  zoom: number;
  transitionDuration: number;
}

export interface MapVesselData {
  name: string;
  latitude: number;
  longitude: number;
  color: string;
}

const vessels: MapVesselData[] = [
  {
    name: 'Nea Elpis',
    latitude: -33.210422,
    longitude: 115.071822,
    color: "#32CD32"
  },
  {
    name: 'Nea Tyhi',
    latitude: 11.074332,
    longitude: 97.068803,
    color: "#32CD32"
  },
  {
    name: 'Nueva Fortuna',
    latitude: 5.510422,
    longitude: -47.071822,
    color: "#32CD32"
  },
];

function OverviewMap() {
  const dispatch = useAppDispatch();
  const [viewPort, setViewPort] = useState<MapState>({
    latitude: 0,
    longitude: 0,
    zoom: 0,
    transitionDuration: 100,
  });
  const [showPopup, setshowPopup] = useState<any>(null);
  const { data: fleetData } = useSelector((state: TStore) => state.averageFleetDetails);

  useEffect(() => {
    dispatch(getFleetAverage());
  }, []);

  const onClickMarker = (vessel: any) => {
    setshowPopup(vessel);
  };

  const onMove = useCallback((evt: any) => {
    setViewPort(evt.viewState);
  }, []);

  const renderPopup = () => {
    return (
      showPopup && (
        <Popup
          anchor="bottom"
          longitude={showPopup.longitude}
          latitude={showPopup.latitude}
          closeOnClick={false}
          onClose={() => setshowPopup(null)}
          className="custom-popup"
          offset={15}
        >
          <div className="popup-container">
            <div className="popup-header">{showPopup.name}</div>
            <div className="popup-divider" />
            <Link
              className="popup-link"
              to={'/dashboard'}
              onClick={() => dispatch(setSelectedVessel(showPopup.name))}
            >
              View details on dashboard →
            </Link>
          </div>
        </Popup>
      )
    );
  };

  return (
    <div className="overview__map" style={{display: 'flex', height: '100%', width: '100%'}}>
      <Map
        mapboxAccessToken={MAPBOX_TOKEN}
        onMove={onMove}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        maxZoom={4}
        minZoom={0}
        {...viewPort}
      >
        <Pin data={vessels} onClick={onClickMarker} />
        {renderPopup()}
      </Map>
      
      {/* Consistent popup styling to match the other map */}
      <style>{`
        .mapboxgl-popup.custom-popup {
          max-width: 240px;
        }
        
        .mapboxgl-popup.custom-popup .mapboxgl-popup-content {
          padding: 0;
          border-radius: 8px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          border: 1px solid #f0f0f0;
          background-color: #ffffff;
        }
        
        .mapboxgl-popup.custom-popup .mapboxgl-popup-tip {
          border-top-color: #ffffff;
        }
        
        .mapboxgl-popup.custom-popup .mapboxgl-popup-close-button {
          color: #8c8c8c;
          font-size: 16px;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s ease;
        }
        
        .mapboxgl-popup.custom-popup .mapboxgl-popup-close-button:hover {
          background-color: #f5f5f5;
          color: #262626;
        }
        
        @media (prefers-color-scheme: dark) {
          .mapboxgl-popup.custom-popup .mapboxgl-popup-content {
            background-color: #1f1f1f;
            border-color: #434343;
            color: #ffffff;
          }
          
          .mapboxgl-popup.custom-popup .mapboxgl-popup-tip {
            border-top-color: #1f1f1f;
          }
          
          .mapboxgl-popup.custom-popup .mapboxgl-popup-close-button {
            color: #ffffff;
          }
          
          .mapboxgl-popup.custom-popup .mapboxgl-popup-close-button:hover {
            background-color: #2f2f2f;
            color: #69c0ff;
          }
        }
      `}</style>
    </div>
  );
};

export default OverviewMap;